/* PACKRUSH v2 — hero stage, rails, reveal, tabs, filters, marquee pause. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ready = function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); };
  var onAll = function (fn) { ready(fn); document.addEventListener('shopify:section:load', fn); document.addEventListener('rx:refresh', fn); };

  /* ---------- Reveal on scroll ---------- */
  function reveal() {
    var els = document.querySelectorAll('.rx-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  onAll(reveal);

  /* ---------- Pause heavy animations off-screen ---------- */
  function pauseOffscreen() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('is-paused', !en.isIntersecting); });
    }, { rootMargin: '80px 0px' });
    document.querySelectorAll('[data-rxh], [data-rx-pause]').forEach(function (el) {
      if (el.dataset.rxWatch) return; el.dataset.rxWatch = '1'; io.observe(el);
    });
  }
  onAll(pauseOffscreen);

  /* ---------- Hero tilt (pointer) ---------- */
  function heroTilt() {
    if (reduce || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    document.querySelectorAll('[data-rxh]').forEach(function (hero) {
      if (hero.dataset.rxTilt) return; hero.dataset.rxTilt = '1';
      var stage = hero.querySelector('.rxh__tilt'); if (!stage) return;
      var raf = 0;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          stage.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg');
          stage.style.setProperty('--rx', (-y * 10).toFixed(2) + 'deg');
        });
      });
      hero.addEventListener('pointerleave', function () { stage.style.setProperty('--ry', '0deg'); stage.style.setProperty('--rx', '0deg'); });
    });
  }
  onAll(heroTilt);

  /* ---------- Rails (prev / next) ---------- */
  function syncRail(root) {
    var track = root.querySelector('[data-rx-track]'); if (!track) return;
    var prev = root.querySelector('[data-rx-prev]'), next = root.querySelector('[data-rx-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
    var nav = (prev || next) && (prev || next).parentElement;
    if (nav) nav.style.visibility = max <= 0 ? 'hidden' : '';
  }
  function rails() {
    document.querySelectorAll('[data-rx-rail]').forEach(function (root) {
      var track = root.querySelector('[data-rx-track]');
      if (!track || track.dataset.rxBound) { if (track) syncRail(root); return; }
      track.dataset.rxBound = '1';
      track.addEventListener('scroll', function () { syncRail(root); }, { passive: true });
      window.addEventListener('resize', function () { syncRail(root); });
      syncRail(root);
    });
  }
  onAll(rails);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rx-prev],[data-rx-next]'); if (!b) return;
    var root = b.closest('[data-rx-rail]'); if (!root) return;
    var track = root.querySelector('[data-rx-track]'); if (!track) return;
    var item = track.firstElementChild, step = track.clientWidth;
    if (item) {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0, w = item.getBoundingClientRect().width + gap;
      step = Math.max(1, Math.floor((track.clientWidth + gap) / w)) * w;
    }
    track.scrollBy({ left: b.hasAttribute('data-rx-next') ? step : -step, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- Tabs (product tabs section) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-rx-tab]'); if (!tab) return;
    var root = tab.closest('[data-rx-tabs]'); if (!root) return;
    root.querySelectorAll('[data-rx-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) { panel.hidden = !on; if (on) { panel.querySelectorAll('.rx-reveal').forEach(function (el) { el.classList.add('is-in'); }); var r = panel.querySelector('[data-rx-rail]') || panel; if (r.matches && r.matches('[data-rx-rail]')) syncRail(r); } }
    });
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-rx-tab]'); if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = [].slice.call(tab.closest('[data-rx-tabs]').querySelectorAll('[data-rx-tab]'));
    var i = tabs.indexOf(tab), n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    e.preventDefault(); n.focus(); n.click();
  });

  /* ---------- Filters (drop radar) ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-rx-filter]'); if (!chip) return;
    var root = chip.closest('[data-rx-filters]'); if (!root) return;
    var f = chip.getAttribute('data-rx-filter'), limit = parseInt(root.getAttribute('data-limit'), 10) || 999, n = 0;
    root.querySelectorAll('[data-rx-filter]').forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    root.querySelectorAll('[data-game]').forEach(function (row) {
      var ok = (f === 'all' || row.getAttribute('data-game') === f) && n < limit;
      row.hidden = !ok; if (ok) n++;
    });
    var empty = root.querySelector('[data-rx-empty]'); if (empty) empty.hidden = n > 0;
  });
})();
